export class MessageUtils {
  static commonRequiredFieldErrorMessage = "*Value is required";
}
